/**
 * Iter-46: Client-side SEO defaults per vertical.
 *
 * Mirrors _VERTICAL_SEO in /app/backend/routes/seo_routes.py so the editor
 * can seed default SEO strings into the new-LP form. Backend remains the
 * source of truth — this file only powers the admin UX (placeholder text +
 * "revert to default" button behaviour).
 */

export const VERTICAL_SEO_PRESETS = {
  auto: {
    seo_title_suffix: "Car Accident Lawyer — Free Case Review",
    seo_description:
      "Injured in a car accident? Speak with an experienced auto accident attorney about medical bills, lost wages, and pain & suffering. Free 24/7 case review, no fee unless we win.",
    seo_keywords:
      "car accident lawyer, auto accident attorney, car crash lawyer, MVA attorney, free car accident case review, auto injury lawyer",
  },
  truck: {
    seo_title_suffix: "Truck Accident Lawyer — 18-Wheeler & Semi Truck Cases",
    seo_description:
      "Hit by a semi truck or 18-wheeler? Trucking companies keep teams of lawyers on retainer. Get one on your side. Free case review with experienced truck accident attorneys.",
    seo_keywords:
      "truck accident lawyer, 18 wheeler accident attorney, semi truck accident lawyer, commercial vehicle attorney, trucking accident lawyer",
  },
  motorcycle: {
    seo_title_suffix: "Motorcycle Accident Lawyer — Rider Representation",
    seo_description:
      "Down on your bike because of someone else? Motorcyclists face insurance bias — you need a rider-focused attorney. Free case review from experienced motorcycle accident lawyers.",
    seo_keywords:
      "motorcycle accident lawyer, motorcycle injury attorney, motorcycle crash lawyer, biker accident lawyer",
  },
  rideshare: {
    seo_title_suffix: "Uber & Lyft Accident Lawyer — Rideshare Case Review",
    seo_description:
      "Hurt in an Uber or Lyft? Rideshare accidents have unique insurance rules — Uber & Lyft carry $1M policies. Free case review from rideshare accident attorneys.",
    seo_keywords:
      "uber accident lawyer, lyft accident attorney, rideshare accident lawyer, uber crash lawyer, lyft injury attorney",
  },
  other: {
    seo_title_suffix: "Personal Injury Lawyer — Free Case Review 24/7",
    seo_description:
      "Hurt because of someone else? Motor-vehicle crashes, slip and falls, medical malpractice, defective products, dog bites — free case review, no fee unless we win.",
    seo_keywords:
      "personal injury lawyer, personal injury attorney, PI lawyer near me, free case review, injury attorney, accident lawyer",
  },
};

/**
 * Build a full default SEO title for a firm + vertical combo.
 * Matches _default_seo_for_vertical() on the backend so the placeholder
 * the admin sees is exactly what the backend will fall back to.
 */
export function defaultSeoTitle(firmName, vertical) {
  const suffix =
    (VERTICAL_SEO_PRESETS[vertical] || VERTICAL_SEO_PRESETS.other)
      .seo_title_suffix;
  const prefix = firmName ? `${firmName} — ` : "";
  return `${prefix}${suffix}`;
}
